module.exports = __webpack_public_path__ + "static/media/bg.1c5b723d.png";


//////////////////
// WEBPACK FOOTER
// ./src/welcome/bg.png
// module id = 549
// module chunks = 0